module.exports = "pegasus_template/assets/glyphicons-halflings-white.png";